import React from 'react';
import StickyHeader from '../common/StickyHeader';
import BannersCarousel from '../common/banners/BannersCarousel';
import LandingSectionProvider from './LandingSectionProvider';
import Upcoming from './Upcoming';
import './style.css';
import LiveMatchesLanding from '../live/LiveMatchesLanding';
import SwiperCardsWh from '../common/banners/SwiperCardsWh';
import SwiperSportsWh from '../common/banners/SwiperSportsWh';
import { TitleSectionNewWh } from './TitleSectionNewWh';
import { TournamentsSectionNewWh } from './TournamentsSectionNewWh';
import { Navigate, useParams } from 'react-router-dom';
import { removeMultipleSlashes } from '../data/sport-utils';
import { systemCode, urls } from '..';
import { usePrematchData } from '../prematch/PrematchDataProvider';
import TournamentsSelectionsProvider from '../common/TournamentsSelectionsProvider';
import TopMatchesNewWh from './TopMatchesNewWh';
import SeoMainContainer from '../data/seo/SeoMainContainer';
import { SeoContext } from '../data/seo/SeoContextProvider';
import { useFetchSeoSettings } from '../data/fetchSeoSettings';
import { useHandleSeoSettings } from '../data/seo/seoUtils';
import { getConfiguration } from '../data/utils/configuration';
import { useFetch } from '../data/fetch/useFetch';
import { parseWidgetData } from '../data/parseWidgetData';
import TopMenu from '../common/TopMenu';
import HighlightedTournaments from '../prematch/HighlightedTournaments';
import SportsMenuWrapper from '../common/SportsMenuWrapper';
import { getLabel } from '../data/labels';
import Loader from '../common/Loader';

export default function LandingNewWh() {
    const conf = getConfiguration();
    const params = useParams();
    const prematchData = usePrematchData();
    let sport = null;
    const seoContext = React.useContext(SeoContext);
    const [seoSettingsState] = useFetchSeoSettings(seoContext && seoContext.pathname, true, conf.seo);
    useHandleSeoSettings(seoSettingsState);

    const [isLoading, isError, data] = useFetch(conf.api.getWidgetCentrali, null, (data) =>
        parseWidgetData(data, false)
    );


    if (isLoading) return <Loader />;
    if (isError) return;


    if (params.sportId != null) {
        const isNumber = !isNaN(Number(params.sportId));
        if (!isNumber) {
            return <Navigate to={removeMultipleSlashes(`${urls.base}/${urls.notFound}`)} />;
        }
        sport = prematchData.sportById[params.sportId];
    } else {
        sport = prematchData.sport.find(s => s.id < 8000);
    }

    if (sport == null) {
        sport = prematchData.sport[0];
    }

    return (
        <LandingSectionProvider>
            <StickyHeader />
            <div id="landing__wh" className="l_0">
                <TopMenu combinedResults={true} title={getLabel('menu.home')} />
                <BannersCarousel onlyGroup={[0, 1]} />
                <SwiperSportsWh />
                {systemCode !== 'SUREBET' && <SwiperCardsWh />}
                <HighlightsSection sports={prematchData.sport} selected={sport} showBackButton={false} showEventsCount={true} />
                <LiveEventsSection />
                {systemCode === 'SUREBET' && <BannersCarousel onlyGroup={2} />}
                <LastMinuteSection data={data} />
                {systemCode === 'SUREBET' && <BannersCarousel onlyGroup={3} />}
                <TopMatchesSection data={data} />
                <SeoMainContainer />
            </div>
        </LandingSectionProvider>
    );
}

// Componente per sezione Highlights (include logica SUREBET)
function HighlightsSection({ sports, selected, showBackButton, showEventsCount }) {
    return (
        <>
            <TitleSectionNewWh className="titleSection-Highlights titleSection-tournaments" title={getLabel('settings.featured')} />
            <TournamentsSelectionsProvider>
                <TournamentsSectionNewWh />
            </TournamentsSelectionsProvider>
            {systemCode === 'SUREBET' && (
                <>
                    <div className="landing-sportsMenuWrapper">
                        <SportsMenuWrapper
                            sports={sports}
                            selected={selected}
                            showBackButton={showBackButton}
                            showEventsCount={showEventsCount}
                        />
                    </div>
                    <SwiperCardsWh />
                    <TitleSectionNewWh className="titleSection-Highlights" title={getLabel('settings.featured')} />
                    <HighlightedTournaments sportId={selected.categories[0].sportRef} categories={selected.categories} />
                </>
            )}
        </>
    );
}

// Componente per eventi live
function LiveEventsSection() {
    return (
        <div className="landing__events-live">
            <TitleSectionNewWh className="titleSection-LiveEvents" title={getLabel('general.eventi_live')} />
            <LiveMatchesLanding />
        </div>
    );
}

// Componente per last minute
function LastMinuteSection({ data }) {
    return (
        <div className="landing__events-last-minute">
            {data?.lastMinute?.sports.length > 0 && (
                <TitleSectionNewWh className="titleSection-lastMinute" title={getLabel('navbar_buttons.last_minute')} />
            )}
            <div className="upcoming__wrapper">
                <Upcoming />
            </div>
        </div>
    );
}

// Componente per top matches
function TopMatchesSection({ data }) {
    return (
        <div className="landing__events-top-matches">
            {data?.topMatches && (
                <TitleSectionNewWh className="titleSection-TopMatch" title={getLabel('prematch.top_matches')} />
            )}
            <div className="top-matches__wrapper" />
            <TopMatchesNewWh />
        </div>
    );
}
